
export const place_holder_vocabulary={
    input_buscar_terminos:"Buscar términos",
    input_palabra_original:"Palabra original",
    input_palabra_en_español:"Palabra en Español",
    Kanji:"Kanji",
    Kanzi:"Kanzi",
        //añadir cuantos vayas ocupando
}